import { render } from "./dataLoad.vue?vue&type=template&id=5f89f8e9&scoped=true&ts=true"
import script from "./dataLoad.vue?vue&type=script&lang=ts"
export * from "./dataLoad.vue?vue&type=script&lang=ts"

import "./dataLoad.vue?vue&type=style&index=0&id=5f89f8e9&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f89f8e9"]])

export default __exports__